module.exports = __webpack_public_path__ + "static/media/MS.9e2aa087.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MS.svg
// module id = 318
// module chunks = 0